'use strict';

import BaseService from './base.service';

class AssignationsService extends BaseService {
  static $inject = ['Assignation', 'SegaUser'];
  Assignation: any;

  constructor(Assignation, SegaUser) {
    super(Assignation, SegaUser);
    Object.assign(this, {
      Assignation
    });
  }

  updateByIds(ids, data) {
    return this.Assignation.updateByIds({
      ids,
      data
    });
  }
}
export default AssignationsService;
